/* eslint-disable max-len */
import React from "react";
import "./christmas-offer.m.css";

const ChristmasOfferPage = () => {
  const handleBuyNow = planId => {
    window.open(`https://razorpay.com/payment-button/${planId}/view`, "_blank");
  };

  return (
    <div styleName="wrapper">
      <h1 styleName="title">Christmas with Newslaundry</h1>
      <br />
      <div styleName="top-wrapper">
        <div styleName="img-wrap">
          <img
            alt="banner"
            src="https://images.assettype.com/newslaundry/2022-01/aaa72797-14d9-4b87-8186-1edf269915af/christmas_campaign_no_date.jpg"
          />
        </div>
        <div styleName="text-wrap">
          <p styleName="description">
            This festive season, be the Santa for free press. With our Christmas
            offer, get your favourite NL masks, Karare Chane mugs, soap sets and
            a lot more on discount. And besides each customised NL gift hamper,
            there is a free giftable subscription too, for your friends and
            family.
            <br />
            <br />
            Get our merchandise for yourself and say you’re a proud member of a
            community that keeps independent media alive. Or give these to
            friends and family, and spread the word about free, accurate and
            independent news.
            <br />
          </p>
        </div>
      </div>
      <br />
      <div styleName="hamper__container">
        <div styleName="hamper__card">
          <h2 styleName="hamper__title">Hamper One</h2>
          <img
            alt=""
            src="https://images.assettype.com/newslaundry/2022-12/f0ec6257-5b29-4e01-adb6-8e7d692c1106/HAMPER_1.jpg"
          />
          <div styleName="hamper__hr"></div>
          <ul>
            <li>
              <span>❄️</span>
              <span>Laptop Stickers</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Fridge Magnets</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Karare Chane Mug</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Sabki Dhulai Soap Set</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Stay Mad/Karare Chane T-Shirt</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Gift 2x One Month Disruptor Subscriptions</span>
            </li>
          </ul>
          <h2 styleName="hamper__price">
            <span styleName="rupee_sign">₹</span>2,000
          </h2>
          <button onClick={() => handleBuyNow("pl_KsCx97OZYlzhNa")}>
            Buy Now
          </button>
        </div>
        <div styleName="hamper__card">
          <h2 styleName="hamper__title">Hamper Two</h2>
          <img
            alt=""
            src="https://images.assettype.com/newslaundry/2022-12/0cb000d1-073b-47c4-9dc2-278c9e3ee444/WhatsApp_Image_2022_12_16_at_11_58_43_AM.jpeg"
          />
          <div styleName="hamper__hr"></div>
          <ul>
            <li>
              <span>❄️</span>
              <span>Laptop Stickers</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Car Stickers</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Fridge Magnets</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Karare Chane Mug</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Sabki Dhulai Soap Set</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Kashmir Ki Kahani Collector&#39;s Edition</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Newslaundry Backpack</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Newslaundry Hoodie</span>
            </li>
            <li>
              <span>❄️</span>
              <span>Gift 5x One Month Disruptor Subscriptions</span>
            </li>
          </ul>
          <h2 styleName="hamper__price">
            <span styleName="rupee_sign">₹</span>5,000
          </h2>
          <button onClick={() => handleBuyNow("pl_KsCztoInH8QdK8")}>
            Buy Now
          </button>
        </div>
      </div>
      <div>
        <strong>Terms &amp; Conditions</strong>
      </div>

      <ul styleName="notes_wrapper">
        <li>
          This is a limited period offer from December 16th, 2022 to January
          3rd, 2023.
        </li>
        <li>Delivery in India only.</li>
        <li>
          If you are based overseas, please share an Indian delivery address (of
          friends/family).
        </li>
        <li>
          Please note, delivery of packages will take at least two to three
          weeks. Thank you for your patience.
        </li>
        <li>
          We will manually map the gift subscriptions. The subscription will be
          mapped within 48 hours.
        </li>
        <li>
          If you have any queries, please drop an email on{" "}
          <a style={{ color: "#ec2227" }} href="mailto:store@newslaundry.com">
            store@newslaundry.com
          </a>
        </li>
      </ul>
      <br />
      {/* {showDialog ? (
        <SubscriberOnlyNudge handleClose={() => setShowDialog(false)} />
      ) : null} */}
    </div>
  );
};

export { ChristmasOfferPage };
